module.exports = __webpack_public_path__ + "images/c1ebd6e.jpg";